import { Customer } from "./customer";
import { Staff } from "./staff";

export type TodoStatus = "NOT_DONE" | "DONE";

export const todoStatusTrans: Record<TodoStatus, { label: string; color: string; bgcolor: string }> = {
  NOT_DONE: { label: "Chưa làm", color: "#b54708", bgcolor: "#fffaeb" },
  DONE: { label: "Đã làm", color: "#027a48", bgcolor: "#d1fadf" },
};

export const todoStatusOptions: { label: string; value: TodoStatus }[] = (
  Object.keys(todoStatusTrans) as TodoStatus[]
).map((value) => ({
  value,
  label: todoStatusTrans[value].label,
}));

export interface Todo {
  id: number;
  createdAt: number;
  updatedAt: number;
  isDeleted: boolean;
  name: string;
  deadlineAt: number;
  status: TodoStatus;
  internalNote: string | null;
  staff: Staff | null;
  customer?: Customer | null;
}
